import { render, staticRenderFns } from "./DigitalAPI.vue?vue&type=template&id=1a5574f2&"
import script from "./DigitalAPI.vue?vue&type=script&lang=js&"
export * from "./DigitalAPI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports